import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

export default function NoResults() {
    const {
        response: { query }
    } = useAppState()

    return (
        <div class="ns-text-align-center ns-my-5 ns-mx-0">
            <div class="ns-font-4" role="status" aria-live="polite">No results found for '{query}'</div>
            <div class="nosto-rec-container">
                <div class="nosto_element" id="noresults-nosto-1"></div>
            </div>
        </div>
    )
}
